import { render, staticRenderFns } from "./Type5Form.vue?vue&type=template&id=5c168a6f&scoped=true&"
import script from "./Type5Form.vue?vue&type=script&lang=js&"
export * from "./Type5Form.vue?vue&type=script&lang=js&"
import style0 from "./Type5Form.vue?vue&type=style&index=0&id=5c168a6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c168a6f",
  null
  
)

export default component.exports